import React, { CSSProperties } from 'react';
import { Card } from 'styleguide/Card';
import { TextMD } from 'styleguide/Texts';
import { View } from 'styleguide/View';
import DownloadAppstore from 'assets/download-appstore.svg';
import DownloadGooglePlay from 'assets/download-googleplay.svg';
import { SecondaryButton } from 'styleguide/Buttons';

interface Props {
  username: string;
  onCopyPress: () => void;
  style?: CSSProperties;
}

export const AppStoresCard = ({ username, onCopyPress, style }: Props) => {
  return (
    <View style={style}>
      <Card style={{ padding: 16, marginBottom: 16 }}>
        <TextMD style={{ paddingBottom: 16 }}>
          {`To follow ${username} and track your own workouts, download Hevy for free.`}
        </TextMD>
        <View
          style={{
            flexDirection: 'row',
            justifyContent: 'center',
            gap: '16px',
          }}
        >
          <a href="https://hevyapp.app.link/z8OJYs7sUqb">
            <DownloadAppstore style={{ height: 48 }} />
          </a>
          <a href="https://hevyapp.app.link/onXEhIQsUqb">
            <DownloadGooglePlay style={{ height: 48 }} />
          </a>
        </View>
      </Card>
      <SecondaryButton title="Copy Link" onClick={onCopyPress} />
    </View>
  );
};
